import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import InvestigationStatusService from "services/InvestigationStatus";
import {
  invalidateInvestigationStatusesTableQuery,
  useInvestigationStatusesTable,
} from "hooks/useInvestigationStatusesTable";
import InvestigationStatusForm from "routes/investigation_status/components/InvestigationStatusForm";

export const INVESTIGATION_STATUSES_TABLE_CONSTANTS = {
  tableName: "investigation_statuses",
  queryKey: "investigation_statuses",
  className: "InvestigationStatus",
  header: "Investigation Statuses",
  headerIcon: "building",
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.investigationStatus.create];

const InvestigationStatusesTableV3 = () => {
  const { filters, columns } = useInvestigationStatusesTable({
    tableName: INVESTIGATION_STATUSES_TABLE_CONSTANTS.tableName,
  });

  const fetchInvestigationStatuses = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        let response =
          await InvestigationStatusService.getInvestigationStatusesAsTable(
            nextQueryParams
          );

        return response;
      } catch (error) {
        console.error("Error fetching investigation statuses:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      queryKey={INVESTIGATION_STATUSES_TABLE_CONSTANTS.queryKey}
      className={INVESTIGATION_STATUSES_TABLE_CONSTANTS.className}
      tableName={INVESTIGATION_STATUSES_TABLE_CONSTANTS.tableName}
      header={INVESTIGATION_STATUSES_TABLE_CONSTANTS.header}
      headerIcon={INVESTIGATION_STATUSES_TABLE_CONSTANTS.headerIcon}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <FormDialog
            FormComponent={InvestigationStatusForm}
            modelType="Investigation Status"
            onSuccess={invalidateInvestigationStatusesTableQuery}
          />
        </Authorized>
      }
      enableSearch
      enableSettings
      fetchData={fetchInvestigationStatuses}
      invalidateData={invalidateInvestigationStatusesTableQuery}
    />
  );
};

export default InvestigationStatusesTableV3;
